export const ErrorMessages: { [key: number]: string } = {
  400: 'Solicitud incorrecta',
  401: 'No autorizado',
  403: 'Acceso denegado',
  404: 'Recurso no encontrado',
  500: 'Error del servidor',
  0: 'Sin conexión al servidor',

  108: 'El RFC no coincide con el nombre proporcionado',
 // 109: 'La placa ya está registrada en el sistema',
  110: 'El NIV no es válido'
};

export const DefaultErrorMessage = 'Ocurrió un error inesperado';

export const SuccessMessages: { [key: number]: string } = {
  200: 'Operación exitosa',
  201: 'Registro creado correctamente'
};
